import type { LayerDef } from "../types";

/**
 * Green index, 0–100, on a 250 m grid.
 *
 * Combines how much publicly-open green space surrounds a point with how far
 * the nearest park of at least a hectare is. Both components ride along on the
 * feature so the score can be broken down rather than taken on faith.
 */
export const GREEN_RAMP = [
  { value: 0, color: "#f7f7f2" },
  { value: 20, color: "#dbead0" },
  { value: 40, color: "#b4d69f" },
  { value: 60, color: "#7fbf6e" },
  { value: 80, color: "#43a047" },
  { value: 100, color: "#1b5e20" },
];

export const greenLayer: LayerDef = {
  id: "green",
  label: "Green index",
  group: "environment",
  description:
    "Open green space around each point, plus how far the nearest park of 1 ha or more is.",
  attribution:
    '<a href="https://data.iledefrance.fr/explore/dataset/espaces-verts-et-boises-surfaciques-ouverts-ou-en-projets-douverture-au-public/">Espaces verts · Institut Paris Region</a>',
  defaultVisible: false,
  legend: {
    unit: "green index",
    stops: [
      { color: "#dbead0", label: "20 — built up" },
      { color: "#b4d69f", label: "40" },
      { color: "#7fbf6e", label: "60" },
      { color: "#43a047", label: "80" },
      { color: "#1b5e20", label: "100 — in the woods" },
    ],
  },
  sources: {
    green: { type: "vector", url: "pmtiles:///tiles/green.pmtiles" },
  },
  layers: [
    {
      id: "green-fill",
      type: "fill",
      source: "green",
      "source-layer": "green",
      minzoom: 9,
      paint: {
        "fill-color": [
          "interpolate",
          ["linear"],
          ["get", "score"],
          ...GREEN_RAMP.flatMap((s) => [s.value, s.color]),
        ] as never,
        // Ramps up with zoom: at region scale it should read as a wash, close
        // in it needs to be legible against the streets underneath.
        "fill-opacity": [
          "interpolate", ["linear"], ["zoom"], 9, 0.45, 13, 0.6,
        ] as never,
      },
    },
  ],
};
